import { ContextMenuModalItem } from '@components/operatorPanel/components/elements/ContextMenuModal';

export type BaseActionConfig = Omit<ContextMenuModalItem, 'onPress'>;

import { isWeb, machineStatus, machineStatusColorName } from '@helpers';

export const downloadActionConfig: BaseActionConfig = {
  title: isWeb ? 'Download' : 'Share',
  icon: { name: isWeb ? 'download' : 'share' },
  color: 'Label/Light/Primary',
  width: 15,
  height: 18,
};

export const sendToMachineActionConfig: BaseActionConfig = {
  title: 'Send To Machine',
  color: 'Label/Light/Primary',
  iconGap: 3,
  icon: [
    {
      name: 'arrow',
      width: 8,
      height: 7,
      color: 'Label/Light/Primary',
      transform: 'rotate(180)',
    },
    {
      name: 'sendToMachine',
      width: 19,
      height: 15,
      color: 'Label/Light/Primary',
    },
  ],
};

export const modifyNcFileTypeActionConfig: BaseActionConfig = {
  title: 'Modify NC File Type',
  color: 'Label/Light/Primary',
  iconGap: 6,
  icon: [
    {
      name: 'linked',
      width: 13,
      height: 13,
      color: machineStatusColorName[machineStatus.ACTIVE],
    },
    {
      name: 'change',
      width: 13,
      height: 13,
      color: machineStatusColorName[machineStatus.CHANGE],
    },
    {
      name: 'setup',
      width: 13,
      height: 13,
      color: machineStatusColorName[machineStatus.SETUP],
    },
    {
      name: 'ignore',
      width: 13,
      height: 13,
      color: machineStatusColorName[machineStatus.NOTPRODUCTIVE],
    },
  ],
};

export const clearNcFileTypeActionConfig: BaseActionConfig = {
  title: 'Clear NC File Type',
  color: 'Label/Light/Warning',
  icon: { name: 'clearNCFile', width: 67, height: 21 },
};

export const unlinkNcFileFromJobActionConfig: BaseActionConfig = {
  title: 'Unlink NC File From Job',
  color: 'Label/Light/Warning',
  icon: { name: 'unlink', width: 24, height: 24 },
};
